import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route, Link } from 'react-router';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import TouchLink from '../components/TouchLink';
import TouchButton from '../components/TouchButton';

import ChapterItem from '../components/ChapterItem/ChapterItem';

const LessonChapters = React.createClass({
	mixins: [ReactFireMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

	getInitialState() {
		return {
			book: null,
			chapters: null
		};
	},

	componentWillMount() {
		this.bindAsObject(firebaseRoot.child('content/books').child(this.props.params.bookId), "book");
		this.bindAsArray(firebaseRoot.child('content/chapters').child(this.props.params.bookId), "chapters");
	},

	assessmentChapters(e) {
		e.preventDefault();
		var url = `/assessment/${this.state.book['.key']}/difficulty`;
		// TODO: Store selected chapters
		this.context.history.pushState(null, url, null);
	},

	render() {
		return(
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='default'
					title='Välj kapitel'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<form onSubmit={this.assessmentChapters} className="section-wrap">
						<div className="section-body">
							<ol className="chapters-list assessment">
								{
									this.state.chapters.map(chapter => (
										<ChapterItem
											element="li"
											label={chapter.name}
											key={chapter['.key']}
										    progressbar="33"
										    to={`/lesson/${this.state.book['.key']}/${chapter['.key']}`}
										    icon={chapter.icon ? chapter.icon.toLowerCase() : ""}
										/>
									))
								}
							</ol>
						</div>
						<div className="section-footer">
							<TouchButton type="submit" bsStyle="primary" bsSize="large" block>Nästa</TouchButton>
						</div>
					</form>
				</div>
			</div>
		);
	}
});

export default LessonChapters;



/** WEBPACK FOOTER **
 ** ./src/screens/LessonChapters.js
 **/